import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateUnhappyOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m0 2a12 12 0 1 0 12 12A12 12 0 0 0 16 4m5.6 14a1 1 0 1 1 .1 2h-.31a21.4 21.4 0 0 0-4.41.82l-.55.18A18.6 18.6 0 0 0 14 22.14c-.42.22-.82.45-1.19.67l-.37.23c-.29.18-.5.31-.6.39a1 1 0 0 1-1.13-1.65l.29-.18.41-.26c.52-.32 1.09-.65 1.69-1a23 23 0 0 1 2.26-1l.51-.18a22.7 22.7 0 0 1 5.39-1.09ZM12 11a2 2 0 1 1-2 2 2 2 0 0 1 2-2m8 0a2 2 0 1 1-2 2 2 2 0 0 1 2-2"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRateUnhappyOutlineSVG);
ForwardRef.displayName = "IconRateUnhappyOutline";
export { ForwardRef as IconRateUnhappyOutline };
